import { render } from "./LoginPage.vue?vue&type=template&id=8ecbfbe6&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=8ecbfbe6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc07\\Documents\\GitHub\\lezione-online-test\\gatthotel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ecbfbe6"]])

export default __exports__